<template>
  <b-container v-if="Date.now() < new Date(conference.registrationDateTime.seconds*1000)">
    <h2>Register for {{conference.title}}</h2>
      <b-row align-h="center">
        <b-card no-body class="overflow-hidden" style="max-width: 540px; min-width: 540px;">
          <b-row no-gutters>
            <b-col md="12" v-if="conference.logoURL">
              <b-card-img :src="conference.logoURL" class="rounded-0" />
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col md="12">
              <b-card-body :title="conference.title">
                <b-card-text>
                  {{ conference.startDateTime.seconds | moment("dddd, MMMM Do YYYY, h:mm a") }}
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-row>
      <b-row>
        <b-col md="12" v-html=conference.description>
        </b-col>
      </b-row>
        <hr v-if="conference.logoURL">
        <b-form @submit="register" @reset="onFormReset" v-if="show">
                <b-row>
            <b-col lg="6">
              <b-form-group id="conferenceFirstNameInputGroup"
                            class="label-heading"
                            label="First Name"
                            label-for="conferenceFirstNameInput"
                            label-align="left"
                            >
                <b-form-input v-model="model.userFirstName" type="text"/>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
              <b-form-group id="conferenceLastNameInputGroup"
                            class="label-heading"
                            label="Last Name"
                            label-for="conferenceLastNameInput"
                            label-align="left"
                            >
                <b-form-input v-model="model.userLastName" type="text"/>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row>
          <b-col lg="6">
              <b-form-group id="conferenceUserCredentialsInputGroup"
                            class="label-heading"
                            label="Credentials"
                            label-for="conferenceUserCredentialsInput"
                            label-align="left"
                            >
                <b-form-input v-model="model.userCredentials" type="text"/>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row>
          <b-col lg="6">
              <b-form-group id="conferenceAffiliationInputGroup"
                            class="label-heading"
                            label="Affiliation"
                            label-for="conferenceAffiliationInput"
                            label-align="left"
                            >
                <b-form-input v-model="model.userAffiliation" type="text"/>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="conference.askCME" class="form-row-margin">
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxCME"
                     v-model="model.cmeCredit"
                     >
                     I am requesting CME credit for this Event
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="conference.askResearchBlitz" class="form-row-margin">
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxResearchBlitz"
                     v-model="model.askResearchBlitz"
                     >
                     I am participating in the Research Blitz
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="conference.askTShirt">
            <b-col md="6">
                <b-form-group id="conferenceTShirtInputGroup"
                                class="label-heading"
                                label="Choose a T-Shirt Size"
                                label-for="conferenceTShirtInput">
                    <b-form-select required v-model="model.tShirtSize" :options="tShirtOptions" class="mb-3" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="conference.askBreakfast">
            <b-col md="6">
                <b-form-group id="conferenceBreakfastInputGroup"
                                class="label-heading"
                                :label="conference.breakfastQuestionText"
                                label-for="conferenceBreakfastInput">
                    <b-form-select required v-model="model.breakfastSelection" :options="conference.breakfastOptions" class="mb-3" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="conference.askLunch">
            <b-col md="6">
                <b-form-group id="conferenceLunchInputGroup"
                                class="label-heading"
                                :label="conference.lunchQuestionText"
                                label-for="conferenceLunchInput">
                    <b-form-select required v-model="model.lunchSelection" :options="conference.lunchOptions" class="mb-3" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="conference.askDinner">
            <b-col md="6">
                <b-form-group id="conferenceDinnerInputGroup"
                                class="label-heading"
                                :label="conference.dinnerQuestionText"
                                label-for="conferenceDinnerInput">
                    <b-form-select required v-model="model.dinnerSelection" :options="conference.dinnerOptions" class="mb-3" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="conference.askSpecialNeeds">
            <b-col>
              <b-form-group id="conferenceSpecialNeedsInputGroup"
                            class="label-heading"
                            label="Special Needs (500 character limit)"
                            label-for="conferenceSpecialNeedsInput"
                            :description="(500-model.specialNeeds.length).toString() + ' characters remaining'"
                            >
                <b-form-textarea v-model="model.specialNeeds"
                  type="textarea"
                  placeholder="Please let us know of any special needs (mobility/food allergies/etc.)"
                  :rows="4"
                  maxlength=500></b-form-textarea>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="conference.askSocialEvents">
            <b-col md="8">
              <b-form-group id="conferenceSocialEventsInputGroup"
                                  class="label-heading"
                                  label="Please choose any special events you would like to attend"
                                  label-for="conferenceSocialEventsInput">
                <small id="specialEventsHelp" class="form-text text-muted">Use Control key to select multiple items (Mac users use option key)</small>
                <b-form-select multiple :select-size="4" v-model="model.socialEvents" :options="conference.socialEventsOptions" class="mb-3" />
              </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="conference.askEventReferral">
            <b-col>
              <b-form-group id="conferenceEventReferralInputGroup"
                            class="label-heading"
                            label="How did you hear about this event"
                            label-for="conferenceEventReferralInput"
                            >
                <b-form-input v-model="model.eventReferral" type="text"/>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="conference.extraQuestions" class="form-row-margin">
          <b-col md="12" class="text-left" v-for="extraQuestion in conference.extraQuestions" :key="extraQuestion.model">
              <b-form-checkbox v-if="extraQuestion.type === 'radio'" :id="'extraQuestion['  + extraQuestion.model  + ']'"
                     v-model="model.extraQuestions[extraQuestion.model]"
                     >
                     {{extraQuestion.label}}
              </b-form-checkbox>
              <b-form-group v-if="extraQuestion.type === 'input'"
                            :id="'extraQuestion['  + extraQuestion.model  + ']'"
                            class="label-heading"
                            :label=extraQuestion.label
                            label-align="left"
                            >
                <b-form-input v-model="model.extraQuestions[extraQuestion.model]" type="text"/>
              </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="conference.askPosterJudging" class="form-row-margin">
          <b-col md="6" class="text-left">
              <b-form-checkbox id="checkboxPosterJudging"
                     v-model="model.posterJudging"
                     >
                     I am interested in judging posters for this Event
              </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="conference.askPosterSpecifics">
          <b-col md="6">
            <b-form-group id="conferencePosterSpecificsInputGroup"
                          class="label-heading"
                          label="Poster Abstract Submission"
                          label-for="conferencePosterSpecificsInput">
              <b-form-select required v-model="model.posterSubmission" :options="posterSpecificOptions" class="mb-3" />
            </b-form-group>
          </b-col>
        </b-row>
        <div v-if="model.posterSubmission == 'I WILL submit an abstract'">
          <b-row>
            <b-col md="6">
              <b-form-group id="conferencePosterCategoryInputGroup"
                            class="label-heading"
                            label="Submission Category"
                            label-for="conferencePosterCategoryInput">
                <b-form-select required v-model="model.posterSubmissionCategory" :options="conference.posterCategoryOptions" class="mb-3" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="conference.askPosterSubmissionTopic">
            <b-col md="6">
              <b-form-group id="conferencePosterSubmissionTopicInputGroup"
                                  class="label-heading"
                                  label="Submission Topic"
                                  label-for="conferencePosterSubmissionTopicInput">
                <b-form-select required v-model="model.posterSubmissionTopic" :options="conference.posterSubmissionTopicOptions" class="mb-3" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="form-row-margin">
            <b-col cols="2">
              <b-button size="lg" variant="success" class="mr-1" v-b-modal.addAuthorModal>
                Add Author
              </b-button>
            </b-col>
          </b-row>
          <b-row class="form-row-margin" v-for="(item, index) in model.posterAuthors" :key="index">
            <b-col sm="12" md="6">
              <div>
                <b-card-group deck>
                  <b-card
                        header-tag="header"
                        footer-tag="footer"
                  >
                    <h6 slot="header" class="mb-0">{{item.firstName}} {{item.lastName}} {{item.credentials}}</h6>
                    <b-button-group slot="footer">
                      <b-button v-if="index !=0" variant="success" @click="reorderAuthors(index, index-1)">Move Up</b-button>
                      <b-button v-if="index+1 != model.posterAuthors.length" variant="primary" @click="reorderAuthors(index, index+1)">Move Down</b-button>
                      <b-button variant="danger" @click="removeAuthor(index)">Delete Author</b-button>
                    </b-button-group>
                    <p class="card-text">Department: {{item.department}}</p>
                    <p class="card-text">Institution: {{item.institution}}</p>
                  </b-card>
                </b-card-group>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="conferencePosterSubmissionTitleInputGroup"
                            class="label-heading"
                            label="Submission Title"
                            label-for="conferencePosterSubmissionTitleInput">
                <b-input-group size="lg" :append="(150-model.posterSubmissionTitle.length).toString() + ' characters remaining'">
                <b-form-input v-model="model.posterSubmissionTitle"
                  type="text"
                  required
                  placeholder="Enter your Poster Title"
                  maxlength=150></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="conferencePosterSubmissionAbstractInputGroup"
                            class="label-heading"
                            label="Submission Abstract (3000 character limit)"
                            label-for="conferencePosterSubmissionAbstractInput"
                            :invalid-feedback="invalidFeedback"
                            :valid-feedback="validFeedback"
                            :state="state"
                            >
              <quill-editor v-model="model.posterSubmissionAbstract"
                            ref="myQuillEditor"
                            :options="editorOption"
                            @change="onEditorChange($event)">
              </quill-editor>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="conference.extraPosterQuestions" class="form-row-margin">
            <b-col md="12" class="text-left" v-for="extraPosterQuestion in conference.extraPosterQuestions" :key="extraPosterQuestion.model">
              <b-form-checkbox v-if="extraPosterQuestion.type === 'radio'" :id="'extraPosterQuestion['  + extraPosterQuestion.model  + ']'"
                     v-model="model.extraPosterQuestions[extraPosterQuestion.model]"
                     >
                     {{extraPosterQuestion.label}}
              </b-form-checkbox>
              <b-form-group v-if="extraPosterQuestion.type === 'input'"
                            :id="'extraPosterQuestion['  + extraPosterQuestion.model  + ']'"
                            class="label-heading"
                            :label=extraPosterQuestion.label
                            label-align="left"
                            >
                <b-form-input v-model="model.extraPosterQuestions[extraPosterQuestion.model]" type="text"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      <b-button type="reset" variant="danger">Reset</b-button>
      <b-button v-if="state" variant="success" type="submit" validateBeforeSubmit=true :disabled="registering">Register</b-button>
      </b-form>
      <b-modal
          id="addAuthorModal"
          title="Add an Author"
          @ok="onSubmit"
          @hide="onReset"
          @cancel="onReset"
          ok-title="Submit"
          ref="addAuthorModal"
      >
        <b-row class="form-row-margin">
          <b-col cols="12">
            <input class="form-control" type="text" required v-model="author.firstName" placeholder="First Name">
          </b-col>
        </b-row>
        <b-row class="form-row-margin">
          <b-col cols="12">
            <input class="form-control" type="text" required v-model="author.lastName" placeholder="Last Name">
          </b-col>
        </b-row>
        <b-row class="form-row-margin">
          <b-col cols="12">
            <b-form-group label="Please select applicable credentials">
              <b-form-select id="credentials" name="credentials" v-model="author.credentials" :options="options" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="form-row-margin">
          <b-col cols="12">
            <input class="form-control" type="text" required v-model="author.department" placeholder="Department">
          </b-col>
        </b-row>
        <b-row class="form-row-margin">
          <b-col cols="12">
            <b-form-group label="Please select an Institution or add one below">
            <div>
              <b-form-select v-model="author.institution" :options="institutions" size="lg" />
            </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="form-row-margin">
          <b-col cols="12">
            <input class="form-control" type="text" v-model="author.institution" placeholder="Or enter Institution here if not in dropdown">
          </b-col>
        </b-row>
      </b-modal>
  </b-container>
</template>

<script>
import { db } from '../main'

export default {
  name: 'Register',
  firestore () {
    return {
      // conference: db.collection('Conferences').doc(this.$router.currentRoute.params.conferenceId),
      institutions: db.collection('Institutions').orderBy('id')
    }
  },
  data () {
    return {
      show: true,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            ['clean']
          ]
        }
      },
      registering: false,
      state: true,
      validFeedback: '',
      invalidFeedback: '',
      institutions: [],
      posterSpecificOptions: [
        {value: null, text: 'Please choose whether or not you will submit an abstract'},
        'I am not submitting an abstract',
        'I WILL submit an abstract',
        'I WILL BE submitting an abstract and will come back later and submit it'
      ],
      tShirtOptions: [
        {value: null, text: 'Please select a T-Shirt Size'},
        {value: 'Small', text: 'Small'},
        {value: 'Medium', text: 'Medium'},
        {value: 'Large', text: 'Large'},
        {value: 'XL', text: 'X-Large'},
        {value: 'XXL', text: 'XX-Large'},
        {value: 'None', text: 'No T-Shirt Wanted'}
      ],
      formOptions: {
        validateAfterChanged: true
      },
      conference: {},
      model: {
        askResearchBlitz: false,
        posterSubmission: null,
        posterSubmissionCategory: null,
        posterSubmissionTopic: null,
        posterJudging: false,
        posterSubmissionAbstract: '',
        specialNeeds: '',
        posterSubmissionTitle: '',
        conference: {},
        socialEvents: [],
        posterAuthors: [],
        posterPresenterLocations: [],
        dinnerSelection: null,
        lunchSelection: null,
        breakfastSelection: null,
        tShirtSize: null,
        extraQuestions: {},
        extraPosterQuestions: {}
      },
      formValid: false,
      author: {},
      breakfastOptions: true,
      lunchOptions: true,
      dinnerOptions: true,
      topicOptions: true,
      categoryOptions: true,
      options: [
        { value: null, text: 'None' },
        { value: 'MD', text: 'MD' },
        { value: 'PhD', text: 'PhD' },
        { value: 'MD, PhD', text: 'MD, PhD' },
        { value: 'MS', text: 'MS' },
        { value: 'RN', text: 'RN' },
        { value: 'PharmD', text: 'PharmD' },
        { value: 'DDS', text: 'DDS' },
        { value: 'DMD, ScD', text: 'DMD, ScD' },
        { value: 'DVM, PhD', text: 'DVM, PhD' },
        { value: 'PhD, D.Sc', text: 'PhD, D.Sc' },
        { value: 'D.Sc', text: 'D.Sc' },
        { value: 'DO', text: 'DO' },
        { value: 'Other', text: 'Other' }
      ]
    }
  },
  methods: {
    onValidated (isValid, errors) {
      if (isValid) {
        this.formValid = true
      } else {
        this.formValid = false
      }
    },
    onFormReset (evt) {
      evt.preventDefault()
      this.invalidFeedback = ''
      this.validFeedback = ''
      this.model = {
        posterSubmission: null,
        posterSubmissionCategory: null,
        posterSubmissionTopic: null,
        posterSubmissionAbstract: '',
        specialNeeds: '',
        posterSubmissionTitle: '',
        conference: {},
        socialEvents: [],
        posterAuthors: [],
        posterPresenterLocations: [],
        dinnerSelection: null,
        lunchSelection: null,
        breakfastSelection: null,
        tShirtSize: null
      }
      // this.show = false
      // this.$nextTick(() => { this.show = true })
    },
    register (evt) {
      evt.preventDefault()
      this.registering = true
      var modelData = this
      var docRef = db.collection('Registrations').where('userId', '==', this.$store.getters.getUser.uid).where('conference.Id', '==', this.$router.currentRoute.params.conferenceId)
      docRef.get().then(doc => {
        if (!doc.empty) {
          alert('You have already registered for this conference previously.  Please check your "My Conferences" tab to view the details.')
        } else {
          // doc.data() will be undefined in this case
          modelData.model.posterAuthors.forEach(author => {
            modelData.model.posterPresenterLocations.push(author.departmentInstitution)
          })
          modelData.model.posterPresenterLocations = [...new Set(modelData.model.posterPresenterLocations)]
          modelData.model.posterAuthors.forEach((author, index, authorArray) => {
            modelData.model.posterAuthors[index].locationIndex = modelData.model.posterPresenterLocations.indexOf(author.departmentInstitution)
          })
          modelData.model.conference = modelData.conference
          delete modelData.model.conference.breakfastNeeded
          delete modelData.model.conference.lunchesNeeded
          delete modelData.model.conference.dinnersNeeded
          delete modelData.model.conference.tShirtsNeeded
          modelData.model.userId = modelData.$store.getters.getUser.uid
          modelData.model.displayName = modelData.$store.getters.getUser.displayName
          modelData.model.email = modelData.$store.getters.getUser.email
          modelData.model.registrationCreatedAt = new Date(Date.now())
          modelData.model.conference.Id = this.$router.currentRoute.params.conferenceId
          if (this.model.posterSubmission !== 'I WILL submit an abstract') {
            this.model.posterSubmissionCategory = ''
            this.model.posterSubmissionTitle = ''
            this.model.posterSubmissionAbstract = ''
          } else {
            if (modelData.model.posterAuthors.length === 0) {
              alert('You must have at least one author for your submission')
              this.registering = true
              return
            }
          }
          var batch = db.batch()
          db.collection('Registrations').add(modelData.model)
            .then(docRef => {
              alert('Registration Successful')
              // Create a reference to the Conference doc.
              var conferenceDocRef = db.collection('Conferences').doc(this.$router.currentRoute.params.conferenceId)
              return db.runTransaction(transaction => {
                return transaction.get(conferenceDocRef).then(conferenceDoc => {
                  if (!conferenceDoc.exists) {
                    throw new Error('Document does not exist!')
                  }
                  var newRegistrantCount = (conferenceDoc.data().registrants || 0) + 1
                  batch.update(conferenceDocRef, {registrants: newRegistrantCount})
                  if (modelData.model.breakfastSelection) {
                    var breakfastUpdate = 'breakfastNeeded.' + modelData.model.breakfastSelection
                    var newBreakfastCount = (conferenceDoc.data().breakfastNeeded[modelData.model.breakfastSelection] || 0) + 1
                    batch.update(conferenceDocRef, {[breakfastUpdate]: newBreakfastCount})
                  }
                  if (modelData.model.lunchSelection) {
                    var lunchUpdate = 'lunchesNeeded.' + modelData.model.lunchSelection
                    var newLunchCount = (conferenceDoc.data().lunchesNeeded[modelData.model.lunchSelection] || 0) + 1
                    batch.update(conferenceDocRef, {[lunchUpdate]: newLunchCount})
                  }
                  if (modelData.model.dinnerSelection) {
                    var dinnerUpdate = 'dinnersNeeded.' + modelData.model.dinnerSelection
                    var newDinnerCount = (conferenceDoc.data().dinnersNeeded[modelData.model.dinnerSelection] || 0) + 1
                    batch.update(conferenceDocRef, {[dinnerUpdate]: newDinnerCount})
                  }
                  if (modelData.model.tShirtSize) {
                    var tShirtUpdate = 'tShirtsNeeded.' + modelData.model.tShirtSize
                    var newTShirtCount = (conferenceDoc.data().tShirtsNeeded[modelData.model.tShirtSize] || 0) + 1
                    batch.update(conferenceDocRef, {[tShirtUpdate]: newTShirtCount})
                  }
                  if (modelData.model.socialEvents) {
                    modelData.model.socialEvents.forEach(x => {
                      var socialEventsUpdate = 'socialEventsCount.' + x
                      var newSocialEventsCount = (conferenceDoc.data().socialEventsCount[x] || 0) + 1
                      batch.update(conferenceDocRef, {[socialEventsUpdate]: newSocialEventsCount})
                    })
                  }
                  batch.commit().then(x => {
                    if (this.conference.confirmationPage) {
                      this.$router.replace('/confirmation/' + this.model.conference.Id)
                    } else if (this.conference.paymentPage) {
                      window.location.replace(this.conference.paymentURL)
                    } else {
                      this.$router.replace('/conferences')
                    }
                  })
                })
              }).then(x => {
                console.log('Transaction successfully committed!')
                if (this.conference.confirmationPage) {
                  this.$router.replace('/confirmation/' + this.model.conference.Id)
                } else if (this.conference.paymentPage) {
                  window.location.replace(this.conference.paymentURL)
                } else {
                  this.$router.replace('/conferences')
                }
              }).catch(function (error) {
                this.registering = false
                console.log('Transaction failed: ', error)
              })
            }).catch(function (error) {
              this.registering = false
              console.log('Transaction failed: ', error)
            })
        }
      }).catch(function (error) {
        console.log('Error getting document: ', error)
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.author.locationIndex = null
      this.author.departmentInstitution = this.author.department + ' ' + this.author.institution
      this.model.posterAuthors.push(this.author)
      this.$refs.addAuthorModal.hide()
    },
    onReset (evt) {
      this.author = {}
    },
    reorderAuthors (index, newIndex) {
      Array.prototype.move = function (from, to) {
        this.splice(to, 0, this.splice(from, 1)[0])
      }
      this.model.posterAuthors.move(index, newIndex)
    },
    removeAuthor (index) {
      this.model.posterAuthors.splice(index, 1)
    },
    onEditorChange (event) {
      this.state = event.text.length <= 3000 ? true : false
      if (this.state) {
        this.validFeedback = 3000 - event.text.length + ' characters remaining'
      } else { this.invalidFeedback = 3000 - event.text.length + ' characters remaining' }
    }
  },
  mounted () {
    this.firestoreListener = db.collection('Conferences').doc(this.$router.currentRoute.params.conferenceId).get().then(doc => {
      if (doc.exists) {
        this.conference = doc.data()
        doc.data().extraQuestions.forEach(extraQuestion => {
          if (extraQuestion.type === 'radio') {
            this.$set(this.model.extraQuestions, extraQuestion.model, false)
          } else {
            this.$set(this.model.extraQuestions, extraQuestion.model, '')
          }
        })
        doc.data().extraPosterQuestions.forEach(extraPosterQuestion => {
          if (extraPosterQuestion.type === 'radio') {
            this.$set(this.model.extraPosterQuestions, extraPosterQuestion.model, false)
          } else {
            this.$set(this.model.extraPosterQuestions, extraPosterQuestion.model, '')
          }
        })
      } else {
        console.log('No such document!')
      }
    }).catch((error) => {
      console.log('Error getting document:', error)
    })
  },
  beforeUpdate () {
    if (this.breakfastOptions && this.conference.askBreakfast) {
      this.conference.breakfastOptions.unshift({ value: null, text: 'Please select an option' })
      this.breakfastOptions = false
    }
    if (this.lunchOptions && this.conference.askLunch) {
      this.conference.lunchOptions.unshift({ value: null, text: 'Please select an option' })
      this.lunchOptions = false
    }
    if (this.dinnerOptions && this.conference.askDinner) {
      this.conference.dinnerOptions.unshift({ value: null, text: 'Please select an option' })
      this.dinnerOptions = false
    }
    if (this.topicOptions && this.conference.askPosterSubmissionTopic) {
      this.conference.posterSubmissionTopicOptions.unshift({ value: null, text: 'Please select an option' })
      this.topicOptions = false
    }
    if (this.categoryOptions) {
      this.conference.posterCategoryOptions.unshift({ value: null, text: 'Please select an option' })
      this.categoryOptions = false
    }
  }
}
</script>

<style scoped>
.vue-form-generator {
  text-align: left;
}
.form-group, .custom-control {
  margin: 20px 0;
}
.btn {
  border-radius: 0px;
}
.b-form-group {
  text-align: left;
}
.form-row-margin {
  margin-bottom: 15px;
}
.list-group-item {
  border-radius: 0px;
}
.label-heading {
  font-size: x-large!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue